"use client";

import { useEffect } from "react";

import { ErrorFallback } from "@/shared/ui/error-fallback";
import { isCmsFetchError } from "@/shared/lib/errors/cms-fetch-error";

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error("[app/error]", error);
  }, [error]);

  const isCms = isCmsFetchError(error);

  return (
    <ErrorFallback
      fullPage
      title={isCms ? "Сайт временно недоступен" : "Что-то пошло не так"}
      message={
        isCms
          ? "Не удалось получить данные с сервера. Попробуйте обновить страницу через несколько минут."
          : "Произошла непредвиденная ошибка. Попробуйте обновить страницу."
      }
      reset={reset}
    />
  );
}
